import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import type { LC_GetWorkingDayTypesListOut, WorkingDayType } from './workingDayType.types';
import { mapWorkingDayTypeOutToModel } from './workingDayType.mapper';


export class WorkingDayTypeCatalogService {
  async getWorkingDayTypes(signal?: AbortSignal): Promise<ApiResponse<WorkingDayType[]>> {
    const response = await apiClient.get<LC_GetWorkingDayTypesListOut>(
      API_CONFIG.ENDPOINTS.CATALOG.WORKING_DAY_TYPES,
      { signal },
    );

    if (response.success && response.data) {
      return {
        ...response,
        data: response.data.map(mapWorkingDayTypeOutToModel),
      };
    }

    return { ...response, data: null };
  }
}

export const workingDayTypeCatalogService = new WorkingDayTypeCatalogService();
